export default "__VITE_ASSET__DNy8jrBW__"